import { defineChapter } from '../../define';
import boss from './challenges/boss/meta';
import debounce from './challenges/debounce/meta';
import errorHandling from './challenges/error-handling/meta';
import parallel from './challenges/parallel/meta';
import promiseOrder from './challenges/promise-order/meta';
import sleep from './challenges/sleep/meta';

export default defineChapter({
  id: 'js-async',
  slug: 'async',
  title: 'Async JavaScript',
  position: 3,
  challenges: [promiseOrder, sleep, errorHandling, debounce, parallel, boss],
});
